import { render, staticRenderFns } from "./taskcreate.vue?vue&type=template&id=05a0c678&scoped=true"
import script from "./taskcreate.vue?vue&type=script&lang=js"
export * from "./taskcreate.vue?vue&type=script&lang=js"
import style0 from "./taskcreate.vue?vue&type=style&index=0&id=05a0c678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0c678",
  null
  
)

export default component.exports